import React from 'react';
import { FaSave, FaSpinner, FaToggleOn, FaToggleOff } from 'react-icons/fa';

const AdminSettingsTab = ({ settings, setSettings, handleSaveSettings, submitting }) => (
  <div className="space-y-6">
    <div className="flex justify-between items-center">
      <h2 className="text-xl font-bold text-white">System Settings</h2>
      <button
        onClick={handleSaveSettings}
        disabled={submitting}
        className="px-4 py-2 bg-gradient-to-r from-[#D4AF37] to-[#FFD700] text-[#0A1929] font-bold rounded-lg flex items-center space-x-2"
        data-testid="save-settings-btn"
      >
        {submitting ? <FaSpinner className="animate-spin" /> : <FaSave />}
        <span>Save Settings</span>
      </button>
    </div>

    <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
      {/* Client Limits */}
      <div className="bg-gradient-to-br from-[#1A2942] to-[#1E3A5F] rounded-xl p-6 border border-[#2D5A8F]">
        <h3 className="text-lg font-bold text-white mb-4">Client Limits</h3>
        <div className="space-y-4">
          <div>
            <label className="block text-gray-400 text-sm mb-2">Default Client Limit</label>
            <input
              type="number"
              value={settings.default_client_limit || 50}
              onChange={(e) => setSettings({ ...settings, default_client_limit: parseInt(e.target.value) })}
              className="w-full px-4 py-2 bg-[#0F172A] border border-[#2D5A8F] rounded-lg text-white"
            />
          </div>
          <div>
            <label className="block text-gray-400 text-sm mb-2">Top-Up Amount</label>
            <input
              type="number"
              value={settings.top_up_amount || 50}
              onChange={(e) => setSettings({ ...settings, top_up_amount: parseInt(e.target.value) })}
              className="w-full px-4 py-2 bg-[#0F172A] border border-[#2D5A8F] rounded-lg text-white"
            />
          </div>
        </div>
      </div>

      {/* App Configuration */}
      <div className="bg-gradient-to-br from-[#1A2942] to-[#1E3A5F] rounded-xl p-6 border border-[#2D5A8F]">
        <h3 className="text-lg font-bold text-white mb-4">App Configuration</h3>
        <div className="space-y-4">
          <div>
            <label className="block text-gray-400 text-sm mb-2">App Name</label>
            <input
              type="text"
              value={settings.app_name || 'Arth Gurukul'}
              onChange={(e) => setSettings({ ...settings, app_name: e.target.value })}
              className="w-full px-4 py-2 bg-[#0F172A] border border-[#2D5A8F] rounded-lg text-white"
            />
          </div>
          <div>
            <label className="block text-gray-400 text-sm mb-2">Support Email</label>
            <input
              type="email"
              value={settings.support_email || ''}
              onChange={(e) => setSettings({ ...settings, support_email: e.target.value })}
              className="w-full px-4 py-2 bg-[#0F172A] border border-[#2D5A8F] rounded-lg text-white"
            />
          </div>
          <div>
            <label className="block text-gray-400 text-sm mb-2">Support Phone</label>
            <input
              type="text"
              value={settings.support_phone || ''}
              onChange={(e) => setSettings({ ...settings, support_phone: e.target.value })}
              className="w-full px-4 py-2 bg-[#0F172A] border border-[#2D5A8F] rounded-lg text-white"
            />
          </div>
        </div>
      </div>

      {/* Feature Toggles */}
      <div className="bg-gradient-to-br from-[#1A2942] to-[#1E3A5F] rounded-xl p-6 border border-[#2D5A8F]">
        <h3 className="text-lg font-bold text-white mb-4">Feature Toggles</h3>
        <div className="space-y-4">
          <div className="flex items-center justify-between">
            <span className="text-gray-300">Enable AI Insights</span>
            <button
              onClick={() => setSettings({ ...settings, enable_ai_insights: !settings.enable_ai_insights })}
              className={`p-2 rounded ${settings.enable_ai_insights ? 'bg-green-600' : 'bg-gray-600'}`}
            >
              {settings.enable_ai_insights ? <FaToggleOn size={24} /> : <FaToggleOff size={24} />}
            </button>
          </div>
          <div className="flex items-center justify-between">
            <span className="text-gray-300">Enable Notifications</span>
            <button
              onClick={() => setSettings({ ...settings, enable_notifications: !settings.enable_notifications })}
              className={`p-2 rounded ${settings.enable_notifications ? 'bg-green-600' : 'bg-gray-600'}`}
            >
              {settings.enable_notifications ? <FaToggleOn size={24} /> : <FaToggleOff size={24} />}
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
);

export default AdminSettingsTab;
